import { Record, List } from 'immutable'

import Address from '../Address'
import Commodity from '../Commodity'
import { enquiryStatus as enquiryStatusC } from '@constants'
import EnquiryItem from './EnquiryItem'
import { getTodayDate } from '@utils'

const EnquiryRecord = Record({
	id: null,
	buyer_id: null,
	buyer: null,
	shipping_address: new Address(),
	billing_address: null,
	cost_metrics: null,
	commodity: new Commodity(),
	currency_id: 'INR',
	country_code: 'IN',
	expiry_date: getTodayDate(true).getTime() + 86400000 * 3,
	enquiry_date: getTodayDate(false).getTime(),

	enquiry_id: '',
	enquiry_photo_id: null,
	enquiry_items: List(),
	unknown_product_requested: false,
	enquiry_status: enquiryStatusC.created,
	converted_to_order: false,
	project_name: '',

	final_quote_buyer: null,
	relationship_manager: null,
	all_supplier_quotes: null,
	top_for_quotes: null,

	access_type: 'web',
	updated_at: null, //date
	updated_by: '',
	created_at: null, //date,
	created_by: '',
	order_date: null,
	other_charges: null,
	enquiry_by: null,
	share_enquiry: true,
	share_order: true,
	expected_delivery_date: null,
	platform: null,
	payment_tenure: null,
	payment_terms_list: null,
	payment_terms: null,
	lc_tenure: null,
	pod_tenure: null,
	advance_tenure: null,
	is_retail: false,
	direct_supplier_connect: null,
	region: '',
	discounting_partner: null,
	mbook_billing_address: null,
})

class Enquiry extends EnquiryRecord {
	constructor(data) {
		super({
			...data,
			enquiry_items: List(data?.enquiry_items?.map((item) => new EnquiryItem(item))),
			commodity: new Commodity(data?.commodity),
		})
	}

	update(updates) {
		return this.merge(updates)
	}

	addNewItem(newItem, isUnknownProduct = false) {
		return this.merge({
			enquiry_items: this.enquiry_items.push(newItem),
			unknown_product_requested: isUnknownProduct || this.unknown_product_requested,
		})
	}

	updateItem(id, data) {
		const itemIndex = this.enquiry_items.findIndex((_i) => _i.id === id)
		const unknownItems = this.enquiry_items.filter((_i) => _i.is_unknown_product && id !== _i.id)
		if (itemIndex > -1) {
			return this.merge({
				enquiry_items: this.enquiry_items.set(itemIndex, data),
				unknown_product_requested: unknownItems.length === 0,
			})
		}
		return this
	}

	deleteItem(id) {
		const itemIndex = this.enquiry_items.findIndex((_i) => _i.id === id)
		const unknownItems = this.enquiry_items.filter((_i) => _i.is_unknown_product && id !== _i.id)
		if (itemIndex > -1) {
			return this.merge({
				enquiry_items: this.enquiry_items.delete(itemIndex),
				unknown_product_requested: unknownItems.length === 0,
			})
		}
		return this
	}

	hasEnquiryItems() {
		return this.enquiry_items && this.enquiry_items.size > 0
	}
}

export default Enquiry
